<template>
  <div class="sidebar-container">
    <el-scrollbar
      wrap-class="m-scrollbar-wrapper"
      style="height: calc(100% - 40px)"
    >
      <el-menu
        ref="menuRef"
        router
        class="sidebar-menu"
        :default-openeds="openeds"
        :default-active="activePath"
        :unique-opened="false"
        :collapse="isCollapse"
      >
        <template v-for="item in menulist">
          <template
            v-if="
              item.children &&
              item.children.filter((child) => !child.hidden).length > 0 &&
              item.path !== '/'
            "
          >
            <el-submenu :index="item.path" :key="item.id">
              <template slot="title">
                <el-image
                  class="menu-icon"
                  :src="require(`@/assets/images/${item.icon}.png`)"
                  fit="fill"
                ></el-image>
                <span slot="title">{{ $t('message.' + item.name) }}</span>
              </template>
              <el-menu-item
                v-for="item1 in item.children.filter((child) => !child.hidden)"
                :key="item1.id"
                :index="item.path + '/' + item1.path"
                >{{ $t('message.' + item1.name) }}</el-menu-item
              >
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item
              :index="item.path === '/' ? '/dashboard' : item.path"
              class="parent_item_title"
              :key="item.id"
            >
              <i class="el-icon-location"></i>
              <span slot="title">{{ $t('message.' + item.name) }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
    <div class="sidebar-footer" @click="handleCollapse">
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { asyncRouterMap } from '@/router';

export default {
  name: 'SideBar',
  data() {
    return {
      openeds: ['/dashboardManagement', '/system'],
    };
  },
  computed: {
    ...mapGetters(['isCollapse']),
    menulist() {
      return asyncRouterMap;
    },
    activePath() {
      const path = this.$route.path.split('/');
      const common = `/${path[1]}`;
      return path.length > 2 ? `${common}/${path[2]}` : common;
    },
  },
  methods: {
    handleCollapse() {
      this.$store.commit('app/setCollapse', !this.isCollapse);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  height: 100%;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  .sidebar-footer {
    cursor: pointer;
    height: 40px;
    line-height: 39px;
    border-top: solid 1px $border-color;
    i {
      font-size: 16px;
      color: #606166;
      margin-left: 20px;
      cursor: pointer;
      transition: all linear 0.2s;
    }
  }
  .sidebar-footer:hover {
    i {
      color: $primary-color;
    }
  }
}

.sidebar-menu {
  border-right: none;
  .menu-icon {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }

  .el-menu-item.is-active {
    // background-color: rgba(51, 112, 255, 0.1);
    background-color: #e9f0ff;
    border-right: 4px solid #2f70ff;
  }

  .el-submenu .el-menu-item {
    height: 40px;
    line-height: 40px;
    padding-left: 55px !important;
    margin-top: 8px;
    color: #606266;
  }
}
</style>

<style lang="scss">
.m-scrollbar-wrapper {
  overflow-x: hidden !important;
}
</style>
